import { KommissionsauftragKopf } from "../types/kommissionsauftrag";
import { KommmissionierungStrategy } from "./kommmissionierung.strategy";
import { KommscheinStrategy } from "./kommschein.strategy";
import { RetourscheinStrategy } from "./retourschein.strategy";
import { MischpaletteStrategy } from './mischpalette.strategy';

export function kommissionierungStrategyFactory(auftrag: KommissionsauftragKopf): KommmissionierungStrategy {
  if(auftrag?.retoure)
    return new RetourscheinStrategy(auftrag?.lagerplatzAuswahl ?? false);

  if (auftrag?.mischpalette)
    return new MischpaletteStrategy(auftrag?.lagerplatzAuswahl ?? false);

  return new KommscheinStrategy(auftrag?.lagerplatzAuswahl ?? false);
}
